import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {NavigationService} from '@services/navigation-service';
import {Location} from '@angular/common';
import {PERM_ACCIONES_ID, PermisosService} from '@services/permisos-service';
import {
  PATH_DASHBOARD,
  PATH_FINANCIERA, PATH_NEW_PRECIO, PATH_NEW_PRECIO_FINANCIERA, PATH_NEW_PRECIO_PIZARRA, PATH_PIPELINE,
  PATH_PIZARRA,
  PATH_PRECIOS,
  PATH_VALIDATE_PIZARRA,
  PATH_VALIDATE_PRECIO, PATH_VALIDATE_PRECIO_FINANCIERA
} from '../../../navigation/navigation.module';
import {PreciosService} from '@services/precios-service';
import {FirebaseMessagingService} from '@services/firebase-messaging.service';

@Component({
  selector: 'app-precios-header',
  templateUrl: './precios-header.component.html',
  styleUrls: ['./precios-header.component.scss']
})
export class PreciosHeaderComponent implements OnInit {

  public selectedTabIndex = 0;

  tabs = {
    precios: 'Mercado AGD',
    pizarra: 'Pizarras',
    dolar: 'Dolar',
  };

  // tomamos el objeto de tabs para obtener el array de nombres
  adminTabs = [this.tabs.precios, this.tabs.pizarra, this.tabs.dolar];

  private crearPrecio = false;
  private crearPrecioPizarra = false;
  private crearPrecioFinanciera = false;
  private validarPrecio = false;
  private validarPrecioPizarra = false;
  private validarPrecioFinanciera = false;

  public preciosBubble: boolean = false;
  public preciosPizarraBubble: boolean = false;
  public preciosFinancieraBubble: boolean = false;

  bubbleClass = '';

  constructor(
    private router: Router,
    private navigationService: NavigationService,
    private location: Location,
    private permisosService: PermisosService,
    private preciosService: PreciosService,
    private firebaseService: FirebaseMessagingService,
  ) {
    // verificamos si se posee permiso a la seccion
    // this.permisosService.verificarAccesoDeURL();

    // con esto construimos el array de tabs preguntando al servicio que tabs estan permitidas, si hay alguna de ellas que no
    // este permitida devolvera el array sin dicha tab
    this.adminTabs = this.permisosService.tabsPermitidas(
      this.adminTabs,
      [PERM_ACCIONES_ID.P_Precios, PERM_ACCIONES_ID.P_PreciosPizarra, PERM_ACCIONES_ID.P_Financiera],
      [this.tabs.precios, this.tabs.pizarra, this.tabs.dolar]);

    // en caso de tener el permiso de precios pero ninguna tab anidada, añadimos una tab manualmente
    if (this.adminTabs.length === 0) {
      this.adminTabs.push('Denegado')
    }

    this.validarPrecio = this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.P_ValidarPrecio);
    this.validarPrecioPizarra = this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.P_ValidarPrecioPizarra);
    this.validarPrecioFinanciera = this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.A_ValidarPrecioFinanciera);
    this.crearPrecio = this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.P_CrearPrecio);
    this.crearPrecioPizarra = this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.P_CrearPrecioPizarra);
    this.crearPrecioFinanciera = this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.A_ValidarPrecioFinanciera);

    if (this.validarPrecio) {
      this.preciosService.checkPrecioFlag$.subscribe(flag => {
        this.preciosBubble = flag;
        this.rebuildBubbleClass();
      });
      this.preciosBubble = preciosService.getPrecioToValidateFlag();
    }
    if (this.validarPrecioPizarra) {
      this.preciosService.checkPrecioPizarraFlag$.subscribe(flag => {
        this.preciosPizarraBubble = flag;
        this.rebuildBubbleClass();
      });
      this.preciosPizarraBubble = this.preciosService.getPrecioPizarraToValidateFlag();
    }
    if (this.validarPrecioFinanciera) {
      this.preciosService.checkPrecioFinancieraFlag$.subscribe(flag => {
        this.preciosFinancieraBubble = flag;
        this.rebuildBubbleClass();
      });
      this.preciosFinancieraBubble = this.preciosService.getPrecioFinancieraToValidateFlag();
    }

  }

  ngOnInit() {

    const url = this.router.url.substring(1);
    if (url === PATH_PIZARRA) {
      const index = this.adminTabs.indexOf(this.tabs.pizarra);
      this.selectedTabIndex = index === -1 ? 0 : index;
      this.selectTab(index);
    } else if (url === PATH_FINANCIERA) {
      const index = this.adminTabs.indexOf(this.tabs.dolar)
      this.selectedTabIndex = index === -1 ? 0 : index;
      this.selectTab(index);
    }

  }

  selectTab(e) {
    switch (this.adminTabs[e]) {
      case this.tabs.precios:
        this.location.go(PATH_PRECIOS);
        this.firebaseService.sendToAnalytics(PATH_PRECIOS);
        break;
      case this.tabs.pizarra:
        this.location.go(PATH_PIZARRA);
        this.firebaseService.sendToAnalytics(PATH_PIZARRA);
        break;
      case this.tabs.dolar:
        this.location.go(PATH_FINANCIERA);
        this.firebaseService.sendToAnalytics(PATH_FINANCIERA);
        break;
    }
  }

  showCreateValidate(create) {
    if (create) {
      return (this.adminTabs[this.selectedTabIndex] === this.tabs.precios && this.crearPrecio) ||
        (this.adminTabs[this.selectedTabIndex] === this.tabs.pizarra && this.crearPrecioPizarra) ||
        (this.adminTabs[this.selectedTabIndex] === this.tabs.dolar && this.crearPrecioFinanciera);
    } else {
      return (this.adminTabs[this.selectedTabIndex] === this.tabs.precios && this.validarPrecio) ||
        (this.adminTabs[this.selectedTabIndex] === this.tabs.pizarra && this.validarPrecioPizarra) ||
        (this.adminTabs[this.selectedTabIndex] === this.tabs.dolar && this.validarPrecioFinanciera);
    }
  }

  onValidatePrecios() {
    if (this.adminTabs[this.selectedTabIndex] === this.tabs.precios) {
      this.router.navigate([PATH_VALIDATE_PRECIO]);
    } else if (this.adminTabs[this.selectedTabIndex] === this.tabs.pizarra) {
      this.router.navigate([PATH_VALIDATE_PIZARRA]);
    } else if (this.adminTabs[this.selectedTabIndex] === this.tabs.dolar) {
      this.router.navigate([PATH_VALIDATE_PRECIO_FINANCIERA]);
    }
  }

  onCreateNewPrecio() {
    if (this.adminTabs[this.selectedTabIndex] === this.tabs.precios) {
      this.router.navigate([PATH_NEW_PRECIO]);
    } else if (this.adminTabs[this.selectedTabIndex] === this.tabs.pizarra) {
      this.router.navigate([PATH_NEW_PRECIO_PIZARRA]);
    } else if (this.adminTabs[this.selectedTabIndex] === this.tabs.dolar) {
      this.router.navigate([PATH_NEW_PRECIO_FINANCIERA]);
    }
  }

  rebuildBubbleClass() {
    let str = '';
    if (this.preciosBubble) {
      str += 'tab-bubble-' + this.adminTabs.indexOf(this.tabs.precios) + ' ';
    }
    if (this.preciosPizarraBubble) {
      str += 'tab-bubble-' + this.adminTabs.indexOf(this.tabs.pizarra) + ' ';
    }
    if (this.preciosFinancieraBubble) {
      str += 'tab-bubble-' + this.adminTabs.indexOf(this.tabs.dolar) + ' ';
    }
    this.bubbleClass = str;
  }

  showValidationBullet() {
    return (this.adminTabs[this.selectedTabIndex] === this.tabs.precios && this.preciosBubble) ||
      (this.adminTabs[this.selectedTabIndex] === this.tabs.pizarra && this.preciosPizarraBubble) ||
      (this.adminTabs[this.selectedTabIndex] === this.tabs.dolar && this.preciosFinancieraBubble);
  }


}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/precios-header/precios-header.component.ts